import { Fragment, memo, ReactElement } from 'react';
import { Accordion, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails } from '@mui/material';
import FormFilter from './form';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';

interface FilterReportProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
}

const FilterReportComponent = ({ open, setOpen }: FilterReportProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-content"
          id="panel-filter-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

FilterReportComponent.displayName = 'Research Report - Filter component';

const FilterReport = memo(FilterReportComponent);

export default FilterReport;
